import { useContext } from 'react';
import I18nContext, { I18nContextProps } from './Context';

const useI18n = () => useContext(I18nContext) as I18nContextProps;

export default useI18n;
